var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 15.39 15.89",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{clip-path:url(#clip-path);}.cls-3{fill:#1c3152;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 15.39,
    height: 15.89
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Untitled-1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M13.61,1.15H11.92c-.35-.77-.76-1-1.74-1H5c-1.05,0-1.42.17-1.81,1H1.63A1.49,1.49,0,0,0,.08,2.73a1.53,1.53,0,0,0,1.5,1.74h.18v9.8c0,1.05.45,1.5,1.49,1.51H12.3c1,0,1.5-.46,1.5-1.51V4.46a1.51,1.51,0,0,0,1.49-1.68,1.52,1.52,0,0,0-1.68-1.63M12.3,14.78h-9c-.5,0-.5,0-.5-.51V4.47h10v9.8c0,.5,0,.5-.5.51M13.6,3.47h-12c-.27,0-.56-.08-.55-.73,0-.4.17-.59.56-.59H3.85L4,1.84c.28-.67.28-.67,1-.67h5.19c.69,0,.69,0,.93.65l.13.33H13.6c.52,0,.69.15.69.64s-.16.67-.69.68"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M6.08,13.22a.5.5,0,0,1-.5-.5V6.53a.5.5,0,0,1,.5-.5.51.51,0,0,1,.5.5v6.19a.5.5,0,0,1-.5.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M9.39,13.22a.5.5,0,0,1-.5-.5V6.53a.5.5,0,0,1,.5-.5.51.51,0,0,1,.5.5v6.19a.5.5,0,0,1-.5.5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/deleteIcon.283139caf08363134a1ecb02ef8fa1d2.svg";
export { ForwardRef as ReactComponent };